import { Tooltip as T } from 'radix-ui';
import type { ReactNode } from 'react';

export const TooltipProvider = T.Provider;

export function Tooltip({
  label,
  side = 'top',
  children,
  disabled,
}: {
  label: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  children: ReactNode;
  disabled?: boolean;
}) {
  if (disabled) return <>{children}</>;
  return (
    <T.Root>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content
          side={side}
          sideOffset={8}
          className="z-50 rounded-[8px] bg-overlay px-2.5 py-1.5 text-[12.5px] shadow-float data-[state=delayed-open]:animate-in"
        >
          {label}
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
